export const enUSBackstage = {
  title: 'Backstage',
  backToApp: 'Back to app',
  nav: {
    dashboard: 'Dashboard',
    users: 'Users',
    households: 'Households',
  },
  dashboard: {
    title: 'Overview',
    totalUsers: 'Total Users',
    totalHouseholds: 'Total Households',
    totalExpenses: 'Total Expenses',
    totalBills: 'Active Bills',
    releaseTitle: 'Release',
    version: 'Version',
    releaseDate: 'Release date',
  },
  users: {
    title: 'Users',
    name: 'Name',
    email: 'Email',
    household: 'Household',
    createdAt: 'Created',
    backstageAccess: 'Backstage',
    yes: 'Yes',
    no: 'No',
    noUsers: 'No users found.',
  },
  households: {
    title: 'Households',
    name: 'Name',
    members: 'Members',
    expenses: 'Expenses',
    bills: 'Bills',
    noHouseholds: 'No households found.',
  },
};
